import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      header: {
        tagline: "Paradigm Shift in Technology"
      },
      chat: {
        title: "Jeje AI Assistant",
        status: "Online & Ready",
        placeholder: "Type your message here...",
        listening: "Listening..."
      },
      voice: {
        enable: "Enable Voice",
        disable: "Disable Voice",
        startListening: "Start Voice Input"
      },
      prompts: {
        aiAgents: "Tell me about AI Agents",
        autonomy: "How does autonomy work?",
        security: "AI Security Solutions",
        llmTuning: "LLM Fine-tuning",
        ragSolutions: "RAG Implementation",
        enterpriseAI: "Enterprise AI Solutions",
        joinTeam: "How to join Scalovate?",
        getStarted: "Getting started with AI"
      },
      admin: {
        login: "Admin Login",
        email: "Email",
        password: "Password",
        loginButton: "Login",
        dashboard: "Dashboard",
        content: "Content Management",
        chats: "Chat History",
        analytics: "Analytics",
        addContent: "Add New Content",
        subject: "Subject",
        category: "Category",
        details: "Details",
        keywords: "Keywords",
        save: "Save",
        delete: "Delete",
        edit: "Edit",
        cancel: "Cancel",
        chatPrompts: "Chat Prompts",
        totalContent: "Total Content",
        totalChats: "Total Chats",
        activeContent: "Active Content",
        todayChats: "Today's Chats"
      },
      footer: {
        copyright: "© 2025 Scalovate",
        company: "Scalovate Systems Solutions",
        locations: "Qatar • Australia • Canada"
      }
    }
  },
  ar: {
    translation: {
      header: {
        tagline: "نقلة نوعية في التكنولوجيا"
      },
      chat: {
        title: "مساعد جيجي الذكي",
        status: "متصل وجاهز",
        placeholder: "اكتب رسالتك هنا...",
        listening: "أستمع..."
      },
      voice: {
        enable: "تفعيل الصوت",
        disable: "إيقاف الصوت",
        startListening: "بدء الإدخال الصوتي"
      },
      prompts: {
        aiAgents: "أخبرني عن وكلاء الذكاء الاصطناعي",
        autonomy: "كيف يعمل الاستقلال الذاتي؟",
        security: "حلول أمان الذكاء الاصطناعي",
        llmTuning: "ضبط نماذج اللغة الكبيرة",
        ragSolutions: "تنفيذ حلول RAG",
        enterpriseAI: "حلول الذكاء الاصطناعي للمؤسسات",
        joinTeam: "كيفية الانضمام إلى سكالوفيت؟",
        getStarted: "البدء مع الذكاء الاصطناعي"
      },
      admin: {
        login: "تسجيل دخول المدير",
        email: "البريد الإلكتروني",
        password: "كلمة المرور",
        loginButton: "تسجيل الدخول",
        dashboard: "لوحة التحكم",
        content: "إدارة المحتوى",
        chats: "سجل المحادثات",
        analytics: "التحليلات",
        addContent: "إضافة محتوى جديد",
        subject: "الموضوع",
        category: "الفئة",
        details: "التفاصيل",
        keywords: "الكلمات المفتاحية",
        save: "حفظ",
        delete: "حذف",
        edit: "تعديل",
        cancel: "إلغاء",
        chatPrompts: "مطالبات المحادثة",
        totalContent: "إجمالي المحتوى",
        totalChats: "إجمالي المحادثات",
        activeContent: "المحتوى النشط",
        todayChats: "محادثات اليوم"
      },
      footer: {
        copyright: "© 2024 سكالوفيت",
        company: "تقنيات سكالوفيت",
        locations: "الإمارات • أمريكا • الهند"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n; 